import { amountText, dayMonth } from './listFormat';

// The wording of the History page in one place: day headings, an entry's title and second line, its amount.

export const HISTORY_PATH = '/cases/history';
export const HISTORY_TYPES = ['order', 'invoice', 'delivery_note', 'packing_list'];

const EN_WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const dayNum = (iso) => Math.round(Date.parse(`${iso.slice(0, 10)}T00:00:00Z`) / 86400000);

// "Today · 20 Oct", "Yesterday · 19 Oct", "Friday · 17 Oct" (the year is added when it is not this year's). `day` and `today` are the company's own days.
export function dayHeading(t, lang, day, today) {
  if (!day || !/^\d{4}-\d{2}-\d{2}/.test(day)) return '';
  const date = dayMonth(day, lang);
  const sameYear = !today || day.slice(0, 4) === today.slice(0, 4);
  const dated = sameYear ? date : `${date} ${day.slice(0, 4)}`;
  if (today) {
    const diff = dayNum(today) - dayNum(day);
    if (diff === 0) return `${t('cases.hist.today')} · ${dated}`;
    if (diff === 1) return `${t('cases.hist.yesterday')} · ${dated}`;
  }
  const d = new Date(`${day.slice(0, 10)}T00:00:00Z`);
  const weekday = lang === 'it'
    ? new Intl.DateTimeFormat('it-IT', { weekday: 'long', timeZone: 'UTC' }).format(d).replace(/^./, (c) => c.toUpperCase())
    : EN_WEEKDAYS[d.getUTCDay()];
  return `${weekday} · ${dated}`;
}

// "Invoice SI0001685 from Mobus Fabrics" (without the number or the supplier: whatever is known).
export function entryTitle(t, r) {
  const type = t(`cases.hist.type.${r.type}`);
  const supplier = r.supplier && r.supplier.name;
  if (r.number && supplier) return t('cases.hist.title.full', { type, number: r.number, supplier });
  if (r.number) return t('cases.hist.title.noSupplier', { type, number: r.number });
  if (supplier) return t('cases.hist.title.noNumber', { type, supplier });
  return type;
}

const REASON_KEY = {
  price: 'price', quantity: 'quantity', billed_over_delivered: 'billed', duplicate: 'duplicate', vat_error: 'vat', weak_match: 'look', other: 'look',
};

// What the document's case looks like NOW: "Discrepancy: price differs", "Order missing", "Matched", "Done", "Waiting", or "No case"; then "· PO 198664".
export function entrySubtitle(t, r) {
  const c = r.case;
  if (!c) return t('cases.hist.state.noCase');
  let state = '';
  if (c.state === 'discrepancy') state = t('cases.hist.state.discrepancy', { reason: t(`cases.hist.reason.${REASON_KEY[c.reason] || 'look'}`) });
  else if (c.state) state = t(`cases.hist.state.${c.state}`);
  const po = c.po_number ? t('search.po', { n: c.po_number }) : '';
  return [state, po].filter(Boolean).join(' · ');
}

// The amount at the right: only for a case with a disagreement or a missing order, drawn as on the Needs attention rows (E37).
export function entryAmount(t, r, currency) {
  const c = r.case;
  if (!c || (c.state !== 'discrepancy' && c.state !== 'order_missing')) return null;
  return amountText(t, { reason: c.reason, amount: c.amount, amount_kind: c.amount_kind, currency: c.currency, quantity: c.quantity }, currency);
}

// The icon of an entry: the document's own, tinted rust when its case has a disagreement.
export const entryTone = (r) => (r.case && (r.case.state === 'discrepancy' || r.case.state === 'order_missing') && r.case.reason !== 'weak_match' ? 'rust' : r.case && r.case.state === 'done' ? 'green' : 'grey');

// Day groups in the order they arrive: [{ day, rows }].
export function groupByDay(rows) {
  const groups = [];
  for (const r of rows) {
    const last = groups[groups.length - 1];
    if (last && last.day === r.day) last.rows.push(r);
    else groups.push({ day: r.day, rows: [r] });
  }
  return groups;
}
